import { Pipe, PipeTransform } from '@angular/core';
import { OrderData, OrderStatus, OrderStatusMappingValues } from '@zero/shared/util-models';
import { OrderIsOpenPipe } from '../order-is-open/order-is-open.pipe';

@Pipe({
  name: 'orderStatus',
  standalone: true,
})
export class OrderStatusPipe implements PipeTransform {
  public transform(order: OrderData, orderStatus: OrderStatus, execDate?: string): string {
    if (!order) {
      return undefined;
    }

    let status = '';
    if (orderStatus.indexOf('PartiallyFilled') > -1 && orderStatus !== OrderStatus.PartiallyFilled_Filled) {
      status = 'teils';
    }

    const isOpen = new OrderIsOpenPipe().transform(order);

    if (order.matchedImportStorno) {
      return `${status} storniert`;
    } else if (order.transactionKey) {
      return `${status} abgerechnet`;
    } else if (order.execType === 'savings' && isOpen) {
      return 'in Bearbeitung';
    } else if (order.execType === 'fraction' && isOpen) {
      return execDate ? `Ausführung am: ${execDate}, ab 15:00 Uhr` : 'wartend';
    }

    return OrderStatusMappingValues[orderStatus] ?? orderStatus;
  }
}
